import React from 'react';

import FieldString from '../../../components/plain/FieldString';
import FieldEnum from '../../../components/plain/FieldEnum';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';

import {getDefinedValue} from '../../../util/tools';

class TabAABiography extends React.Component {

	constructor(props) {
		super(props);
	}

	biographyCardBuilder = (fieldBiography, index) => {
		let plain = this.props.plain;
		let card = '';
		
		let langText = plain.realm.getEnumerationItemText( plain.enumLanguage, fieldBiography.value.language.value);
		if( langText )
			card += '['+ langText + '] ';
		
		card += getDefinedValue(fieldBiography.value.text.value, '');
		
		if( card.length > 30 ) {
			card = card.substring(0, 27) + '...';
		}
		
		return card;
	} 

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{padding: '10px' }}>
				<FieldList_CardsPanel path={'/biography'} instance={instance} plain={plain} parentField={parentField} 
					itemComponent={BiographyPanel} itemCardBuilder={this.biographyCardBuilder}
					labelEmptyToHeader={true} readOnly={readOnly}
					styles={{
						divMainStyle: {
							marginTop: '10px',
							padding: '10px 10px 10px 10px',
							backgroundColor: 'rgb(200,200,200)',
							border: '1px solid blue'
						},
						divCardsBlock: {
							marginRight: '10px',
							minWidth: '200px',
							backgroundColor: 'rgb(200,200,200)',
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'rgb(230,230,230)',
							minHeight: '18px'
							
						}
					}}
				/>
			</div>
		);
	}
}

class BiographyPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}
	
	render() {
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = plain.instanceReadOnly;
		return (
			<div style={{flexGrow: '1', margin: '0 0 0 15px', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{margin: '10px', padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'language'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ select: {maxWidth: '150px', marginRight: '20px'}}}
						/>
						<FieldEnum instance={instance} path={'format'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1'}}}
						/>
					</div>
					<FieldString instance={instance} path={'text'} parentField={fieldGroup} plain={plain}
						multiline={true} rows={16} cols={60} readOnly={readOnly}
						styles={{ input: {width: '98%'}}}
					 />
				</div>
			</div>
		)
	}
}


export default TabAABiography;